/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Project_BriefInputs */



/**
* | output |
* | --- |
* | "Project Brief" |
*
* @param {Distillation_Project_BriefInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_project_brief = /** @type {((inputs?: Distillation_Project_BriefInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Project_BriefInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektübersicht")
	return /** @type {LocalizedString} */ ("Project Brief")
});